export class AdobeEvents {
	/**
	 * @returns void
	 */
	trackNextButtonClicked() {
		this._trackEvent('contact-form-next-button-clicked');
	}

	/**
	 * @param questions Array<string>
	 * @returns void
	 */
	trackSmartQuestionsAsked(...questions) {
		const result = { questions: [] };
		for (let i = 0; i < questions.length; i++) {
			if (questions[i].length !== 0) {
				result.questions.push(questions[i]);
			}
		}

		this._trackEvent('contact-form-smart-questions-asked', result);
	}

	/**
	 *
	 * @param event string
	 * @param args
	 * @private
	 * @returns void
	 */
	_trackEvent(event, args = {}) {
		if (!(window._satellite instanceof Object)) {
			return;
		}
		window._satellite.track(event, args);
	}
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/utils/adobe-events.js